import { useTranslation } from "react-i18next";

const OrderVehicleFromBMWAGModalContent = () => {
  const { t } = useTranslation();
  return (
    <div className="p-4 m-[1rem] cursor-default">
      <p className="mb-4">
        {t("/vehicles.With a young used BMW you are making the right choice.")}
      </p>

      <p className="mb-4">{t("/vehicles.youCanPurchaseText")}</p>

      <ul className="list-disc pl-5 mb-4 space-y-2">
        <li>
          {t("/vehicles.Large selection of dream cars from different series.")}
        </li>
        <li>{t("/vehicles.Young age of an average of 12 months.")}</li>
        <li>{t("/vehicles.Predominantly high level of equipment.")}</li>
        <li>
          {t("/vehicles.Vehicles with")} <strong>BMW Premium Selection</strong>{" "}
          {t("/vehicles.inspected by your BMW partner have a documented")}{" "}
          <strong>{t("/vehicles.360-degree check")}</strong>
        </li>
        <li>{t("/vehicles.VAT can be shown.")}</li>
        <li>
          {t("/vehicles.Leasing and financing at attractive conditions.")}
        </li>
        <li>{t("/vehicles.Optional with BMW Service Inclusive.")}</li>
        <li>
          {t(
            "/vehicles.Additional security for every young used car through a 2-year warranty following the",
          )}{" "}
          <a
            href="https://www.bmw.de/de/topics/neuwagen/gewaehrleistung.html"
            target="_blank"
            rel="noopener noreferrer"
            className=" font-semibold"
            onClick={(e) => e.stopPropagation()}
          >
            BMW 2+1* {t("/vehicles.warranty")}
          </a>
          .
        </li>
      </ul>

      <p className="mb-4 text-sm">
        *{t("/vehicles.inAdditionToTheStatutoryText")}
      </p>

      <footer className="text-sm text-gray-600 mt-4 ">
        — {t("/vehicles.Young used cars from")}{" "}
        <a
          href="https://www.bmw.de/de/mehr-bmw/bmw-gebrauchte/junge-gebrauchte.html"
          target="_blank"
          rel="noopener noreferrer"
          className="italic text-[var(--primary-dark-color)]"
          onClick={(e) => e.stopPropagation()}
        >
          BMW AG
        </a>
        .
      </footer>
    </div>
  );
};
export default OrderVehicleFromBMWAGModalContent;
